import { Module } from "@nestjs/common";
import { ScheduleModule } from "@nestjs/schedule";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { AddressEntity } from "../Entites@Shahi/address/address-entity";
import { AddressService } from "../Entites@Shahi/address/address-service";
import { AddressRepository } from "../Entites@Shahi/address/address.repo";
import { ColorEntity } from "../Entites@Shahi/color/color-entity";
import { ColorRepository } from "../Entites@Shahi/color/color-repo";
import { ColorService } from "../Entites@Shahi/color/color-service";
import { SizeEntity } from "../Entites@Shahi/size/size-entity";
import { SizeRepository } from "../Entites@Shahi/size/size-repo";
import { SizeService } from "../Entites@Shahi/size/size-service";
import { GantCOLineEntity } from "./entities/gant-co-line.entity";
import { GantOrderschildEntity } from "./entities/gant-orders-child.entity";
import { GantOrdersEntity } from "./entities/gant-orders.entity";
import { GantPdfInfoEntity } from "./entities/gant-pdf.entity";
import { PoPackEntity } from "./entities/po-pack.entity";
import { GantController } from "./gant.controller";
import { GantService } from "./gant.service";
import { GantCoLineRepository } from "./repositories/gant-co-line.repository";
import { GantOrdersRepository } from "./repositories/gant-orders.repo";
import { GantPdfRepo } from "./repositories/gant-pdf.repo";
import { PoPackRepository } from "./repositories/po-pack.repo";

@Module({
  imports: [
    ScheduleModule.forRoot(),
    TypeOrmModule.forFeature([
      GantOrdersEntity,
      GantOrderschildEntity,
      GantPdfInfoEntity,
      GantCOLineEntity,
      AddressEntity,
      ColorEntity,
      SizeEntity,
      PoPackEntity
    ])],
  controllers: [GantController],
  providers: [GantService, GantPdfRepo, ApplicationExceptionHandler, GantOrdersRepository,
    AddressService, AddressRepository, ColorService, ColorRepository, SizeService, SizeRepository, GantCoLineRepository, PoPackRepository, AddressService, ColorService, SizeService
  ]
})
export class GantModule { }